export default "assets/logo-black-e8e3788b.png";